const styles = () => ({
  dialogPaper: {
    overflowY: 'unset',
  },

  dialogContentRoot: {
    overflowY: 'unset',
    width: 600,
  },

  collectionSelectLabel: {
    marginTop: 10,
  },

  circularProgress: {
    color: '#7b8b99',
    margin: '0 47px',
  },

  fieldLabel: {
    paddingBottom: 10,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
    '& svg': {
      marginRight: 10,
    },
  },
});

export default styles;
